export default __webpack_public_path__ + "static/bwh_logo-d439f2082bac8e088740337630226c45.png";